import React, { useState } from 'react';
import './css/Loading.css';

const Loading = () => {
    return (
        <div className="onboarding-loader">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    )
}


export default Loading;